import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { AdvShell } from "@/components/AdvShell";
import { toast } from "sonner";

const field = "w-full bg-race-bg border border-race-line rounded-md px-3 py-2.5 text-sm text-race-txt outline-none focus:border-race-volt";
const label = "block text-xs uppercase tracking-wide text-race-sub mb-1.5";
const src = (u) => (u ? (u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`) : null);

export default function AdvAccount() {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const on = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  useEffect(() => { api.get("/adv/me").then((r) => setF(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setBusy(true);
    try { await api.patch("/adv/account", { first_name: f.first_name, last_name: f.last_name, business_name: f.business_name, website: f.website, phone: f.phone, notify: f.notify });
      toast.success("Account updated");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const uploadLogo = async (file) => {
    if (!file || !file.type.startsWith("image/")) return toast.error("Choose an image.");
    try { const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/adv/creatives/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.patch("/adv/account", { logo_url: data.url });
      setF((s) => ({ ...s, logo_url: data.url })); toast.success("Logo updated");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  if (!f) return <AdvShell><div className="text-race-sub">Loading…</div></AdvShell>;
  return (
    <AdvShell>
      <h1 className="font-heading text-4xl tracking-tight mb-5" data-testid="adv-account-title">Account</h1>
      <div className="bg-race-surface border border-race-line rounded-lg p-6 max-w-2xl space-y-4">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-md bg-race-bg border border-race-line overflow-hidden grid place-items-center text-race-muted text-xs shrink-0">
            {f.logo_url ? <img src={src(f.logo_url)} alt="logo" className="w-full h-full object-cover" /> : "Logo"}
          </div>
          <label className="text-sm text-race-volt hover:underline cursor-pointer" data-testid="adv-logo-upload">Upload business logo<input type="file" accept="image/*" className="hidden" onChange={(e) => uploadLogo(e.target.files?.[0])} /></label>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div><label className={label}>First name</label><input className={field} value={f.first_name || ""} onChange={on("first_name")} data-testid="adv-acct-first" /></div>
          <div><label className={label}>Last name</label><input className={field} value={f.last_name || ""} onChange={on("last_name")} data-testid="adv-acct-last" /></div>
        </div>
        <div><label className={label}>Business / Organization</label><input className={field} value={f.business_name || ""} onChange={on("business_name")} data-testid="adv-acct-business" /></div>
        <div><label className={label}>Email</label><input className={`${field} opacity-60`} value={f.email || ""} disabled /></div>
        <div className="grid grid-cols-2 gap-4">
          <div><label className={label}>Website</label><input className={field} value={f.website || ""} onChange={on("website")} data-testid="adv-acct-website" /></div>
          <div><label className={label}>Phone</label><input className={field} value={f.phone || ""} onChange={on("phone")} data-testid="adv-acct-phone" /></div>
        </div>
        <label className="flex items-center gap-2 text-sm text-race-sub cursor-pointer">
          <input type="checkbox" checked={!!f.notify} onChange={(e) => setF((s) => ({ ...s, notify: e.target.checked }))} data-testid="adv-acct-notify" />
          Email me about campaign status and billing
        </label>
        <button onClick={save} disabled={busy} data-testid="adv-acct-save" className="bg-race-volt text-race-bg font-semibold text-sm px-5 py-2.5 rounded-md hover:opacity-90 disabled:opacity-50">{busy ? "Saving…" : "Save changes"}</button>
      </div>
    </AdvShell>
  );
}
